import { Route, Routes, Link } from "react-router-dom";
import Summary from './pages/summary';
import About from './pages/about';
import Expenses from './pages/expenses'
import Login from './pages/login';
import Register from './pages/Register';
import ForgotPassword from './pages/forgotPassword';
import Verify from './pages/verify'
import ResetPassword from './pages/resetPassword'

function App() {
    return (
        <div className='App'>
            <Routes>
                <Route exact path='/' element={<Login />} />
                <Route path="/Register" element={<Register />} />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path='/summary' element={sessionStorage.getItem("userID") === null ? <Register /> : <Summary />} />
                <Route path="/expenses" element={sessionStorage.getItem("userID") === null ? <Register /> : <Expenses />} />
                <Route path='/about' element={sessionStorage.getItem("userID") === null ? <Register /> : <About />} />
                <Route path="/verify/*" element = {<Verify />} />
                <Route path="/resetPassword/*" element = {<ResetPassword />} />
            </Routes>
        </div>
    )
}

export const backend_url = 'https://cfl-finance-planner-service.liberty.edu/api/';

export default App;